import { ClienteAnaliseMercadoLancamento } from './cliente-analise-mercado-lancamento';
import { ClienteAnaliseMercadoLancamentoMesSave } from './cliente-analise-mercado-lancamento-mes-save';

export class ClienteAnaliseMercadoLancamentoSave {
    perspectiva: number;
    idClienteAnaliseMercado: number;
    idClienteAnaliseMercadoClassificacao: number;
    ano: number;
    lancamento: number;
    periodicidade: number;
    anotacao: string;
    meses: ClienteAnaliseMercadoLancamentoMesSave[] = [];

    constructor(perspectiva: number, entity: ClienteAnaliseMercadoLancamento) {
        if (!entity) {
            return;
        }

        this.perspectiva = perspectiva;
        this.idClienteAnaliseMercado = entity.idClienteAnaliseMercado;
        this.idClienteAnaliseMercadoClassificacao = entity.idClienteAnaliseMercadoClassificacao;
        this.ano = entity.ano;
        this.lancamento = entity.lancamento;
        this.periodicidade = entity.periodicidade;
        this.anotacao = entity.anotacao;
        // Meses
        entity.meses?.forEach(entityMes => {
            const mes = new ClienteAnaliseMercadoLancamentoMesSave(entityMes);
            this.meses.push(mes);
        });
    }
}
